module.exports = __webpack_public_path__ + "img/features-tileset-studio.d905fd12.png";